// csvConverter.js
import Papa from 'papaparse';
import {
    saveAs
} from 'file-saver';

const SHOPIFY_HEADERS = [
    'Handle', 'Title', 'Body (HTML)', 'Vendor', 'Type', 'Tags', 'Published',
    'Option1 Name', 'Option1 Value', 'Option2 Name', 'Option2 Value', 'Option3 Name', 'Option3 Value',
    'Variant SKU', 'Variant Grams', 'Variant Inventory Tracker', 'Variant Inventory Qty',
    'Variant Inventory Policy', 'Variant Fulfillment Service', 'Variant Price', 'Variant Compare At Price',
    'Variant Requires Shipping', 'Variant Taxable', 'Variant Barcode', 'Image Src', 'Image Position',
    'Image Alt Text', 'Gift Card', 'SEO Title', 'SEO Description', 'Google Shopping / Google Product Category',
    'Google Shopping / Gender', 'Google Shopping / Age Group', 'Google Shopping / MPN', 'Google Shopping / AdWords Grouping',
    'Google Shopping / AdWords Labels', 'Google Shopping / Condition', 'Google Shopping / Custom Product',
    'Google Shopping / Custom Label 0', 'Google Shopping / Custom Label 1', 'Google Shopping / Custom Label 2',
    'Google Shopping / Custom Label 3', 'Google Shopping / Custom Label 4', 'Variant Image', 'Variant Weight Unit',
    'Variant Tax Code', 'Cost per item', 'Status'
];

const WOOCOMMERCE_HEADERS = [
    'ID', 'Name', 'Type', 'SKU', 'Short description', 'Description', 'In stock?',
    'Stock', 'Sale price', 'Regular price', 'Categories', 'Tags', 'Vendor', 'Images',
    'Parent ID', 'Attribute 1 name', 'Attribute 1 value(s)', 'Attribute 2 name',
    'Attribute 2 value(s)', 'Attribute 3 name', 'Attribute 3 value(s)'
];

const convertWooCommerceToShopify = (wooData) => {
    return wooData.map(row => {
        const handle = row['post_name'] !== undefined ? row['post_name'] : '';
        const title = row['post_title'] !== undefined ? row['post_title'] : '';
        const body_html = row['post_content'] !== undefined ? row['post_content'] : '';
        const vendor = row['post_author'] !== undefined ? row['post_author'] : '';
        const product_type = row['product_type'] !== undefined ? row['product_type'] : '';
        const tags = row['tags'] !== undefined ? row['tags'] : '';
        const published = row['post_status'] !== undefined && row['post_status'] === 'publish' ? 'TRUE' : 'FALSE';

        const option1_name = 'Color'; // Example attribute name - adjust if needed
        const option1_value = row['attribute1'] !== undefined ? row['attribute1'] : ''; // Adjust column name
        const option2_name = 'Size'; // Example attribute name - adjust if needed
        const option2_value = row['attribute2'] !== undefined ? row['attribute2'] : ''; // Adjust column name

        const variant_sku = row['sku'] !== undefined ? row['sku'] : '';
        const variant_price = row['regular_price'] !== undefined ? row['regular_price'] : '';
        const variant_inventory_qty = row['stock_quantity'] !== undefined ? row['stock_quantity'] : '';
        const variant_inventory_policy = row['manage_stock'] !== undefined && row['manage_stock'] === 'yes' ? 'deny' : 'continue';
        const variant_requires_shipping = row['shipping_required'] !== undefined && row['shipping_required'] === 'yes' ? 'TRUE' : 'FALSE';
        const variant_taxable = row['tax_status'] !== undefined && row['tax_status'] === 'taxable' ? 'TRUE' : 'FALSE';
        const image_src = row['image_url'] !== undefined ? row['image_url'] : '';
        const image_position = 1; // Assuming single image per product
        const image_alt_text = title;

        return {
            'Handle': handle,
            'Title': title,
            'Body (HTML)': body_html,
            'Vendor': vendor,
            'Type': product_type,
            'Tags': tags,
            'Published': published,
            'Option1 Name': option1_name,
            'Option1 Value': option1_value,
            'Option2 Name': option2_name,
            'Option2 Value': option2_value,
            'Option3 Name': '',
            'Option3 Value': '',
            'Variant SKU': variant_sku,
            'Variant Grams': '',
            'Variant Inventory Tracker': 'shopify',
            'Variant Inventory Qty': variant_inventory_qty,
            'Variant Inventory Policy': variant_inventory_policy,
            'Variant Fulfillment Service': 'manual',
            'Variant Price': variant_price,
            'Variant Compare At Price': '',
            'Variant Requires Shipping': variant_requires_shipping,
            'Variant Taxable': variant_taxable,
            'Variant Barcode': '',
            'Image Src': image_src,
            'Image Position': image_position,
            'Image Alt Text': image_alt_text,
            'Gift Card': 'FALSE',
            'SEO Title': '',
            'SEO Description': '',
            'Google Shopping / Google Product Category': '',
            'Google Shopping / Gender': '',
            'Google Shopping / Age Group': '',
            'Google Shopping / MPN': '',
            'Google Shopping / AdWords Grouping': '',
            'Google Shopping / AdWords Labels': '',
            'Google Shopping / Condition': '',
            'Google Shopping / Custom Product': '',
            'Google Shopping / Custom Label 0': '',
            'Google Shopping / Custom Label 1': '',
            'Google Shopping / Custom Label 2': '',
            'Google Shopping / Custom Label 3': '',
            'Google Shopping / Custom Label 4': '',
            'Variant Image': image_src,
            'Variant Weight Unit': 'g',
            'Variant Tax Code': '',
            'Cost per item': '',
            'Status': 'active'
        };
    });
};

const convertShopifyToWooCommerce = (shopifyData) => {
    return shopifyData.map(row => ({
        ID: row.product_id !== undefined ? row.product_id : (row.variant_id !== undefined ? row.variant_id : ''),
        Type: row.variant_id !== undefined ? 'variation' : 'simple',
        SKU: row.variant_sku !== undefined ? row.variant_sku : (row.handle !== undefined ? row.handle : ''),
        Name: row.title !== undefined ? row.title : (row.variant_title !== undefined ? row.variant_title : ''),
        'Short description': row.handle !== undefined ? row.handle : '',
        Description: '', // Shopify body_html not directly in basic export
        'In stock?': row.available !== undefined ? (row.available ? 1 : 0) : '',
        Stock: '', // Inventory quantity not directly available
        'Sale price': row.variant_compare_at_price !== undefined ? row.variant_compare_at_price : '',
        'Regular price': row.variant_price !== undefined ? row.variant_price : '',
        Categories: row.type !== undefined ? row.type : '',
        Tags: row.tags !== undefined ? row.tags : '',
        Vendor: row.vendor !== undefined ? row.vendor : '',
        Images: row.image_src !== undefined ? row.image_src : (row.variant_image !== undefined ? row.variant_image : ''),
        'Parent ID': row.variant_id !== undefined ? `id:${row.product_id}` : '',
        'Attribute 1 name': row.option1 !== undefined ? row.option1 : '',
        'Attribute 1 value(s)': row.option1 !== undefined ? row.option1 : '', // Handle multiple options if needed
        'Attribute 2 name': row.option2 !== undefined ? row.option2 : '',
        'Attribute 2 value(s)': row.option2 !== undefined ? row.option2 : '',
        'Attribute 3 name': row.option3 !== undefined ? row.option3 : '',
        'Attribute 3 value(s)': row.option3 !== undefined ? row.option3 : '',
        // Add more WooCommerce columns and Shopify field mappings as needed
    }));
    // Further logic needed for detailed Shopify options and WooCommerce attributes/variations
};

const handleCSVConversion = (conversionFile, conversionType, onConversionComplete) => {
    if (!conversionFile || !conversionType) {
        console.error('Conversion file or type not provided.');
        return;
    }

    Papa.parse(conversionFile, {
        header: true,
        dynamicTyping: true,
        complete: (results) => {
            const {
                data
            } = results;
            let convertedData = [];
            let filename = '';

            if (conversionType === 'woo-to-shopify') {
                convertedData = convertWooCommerceToShopify(data);
                filename = 'shopify_products.csv';
            } else if (conversionType === 'shopify-to-woo') {
                convertedData = convertShopifyToWooCommerce(data);
                filename = 'woocommerce_products.csv';
            }

            if (convertedData.length > 0) {
                const csv = Papa.unparse(convertedData, {
                    header: true, // Ensure header is included in unparse
                });
                const blob = new Blob([csv], {
                    type: 'text/csv;charset=utf-8'
                });
                saveAs(blob, filename);
                if (onConversionComplete) {
                    onConversionComplete(filename);
                }
            } else {
                alert('No data to convert or an error occurred during conversion.');
            }
        },
        error: (error) => {
            console.error('Error parsing CSV:', error);
            alert('Error parsing the CSV file.');
        },
    });
};

export {
    handleCSVConversion
};